const STORAGE_TEST_KEY = '__storage_test__'

export const isLocalStorageAvailable = () => {
  if (typeof localStorage === 'undefined') return false

  try {
    window.localStorage.setItem(STORAGE_TEST_KEY, 'test')
    window.localStorage.removeItem(STORAGE_TEST_KEY)
    return true
  } catch {
    return false
  }
}
